import React from 'react'
import { Link } from 'react-router-dom';
import { IoCall } from 'react-icons/io5';
import { MdEmail } from 'react-icons/md';
import { MdLocationOn } from 'react-icons/md';



export default function Footer() {
    return (
        <>
            <div className='py-12 md:py-16 lg:py-20 relative bg-gradient-to-b bg-lightred'>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
                    <div className='flex flex-col md:flex-row md:justify-between gap-10 lg:gap-16'>
                        <div className='w-full md:max-w-[352px]'>
                            <div>
                                <Link to="/" className="flex items-center">
                                    {/* <span className="font-bold">Brand</span> */}
                                    <img src="/assets/logo.png" alt="logo" className="h-12 md:h-14 w-auto" />
                                </Link>
                            </div>
                            <p className='mt-6 md:mt-8 text-gray-500 leading-7'>Lörem ipsum plarade derad. Plaheten hemid då bende. Kar kristofobi nesade. Polyck kall. Euvasade väning och pär.</p>
                        </div>
                        <div className='w-full md:max-w-[352px] flex flex-col gap-3'>
                            <h2 className='text-2xl '>Quick Links</h2>
                            <div className='text-neutral-500 hover:text-black   transition-colors'><Link>Daily Darshan</Link></div>
                            <div className='text-neutral-500 hover:text-black   transition-colors'><Link>Live</Link></div>
                            <div className='text-neutral-500 hover:text-black   transition-colors'><Link>Activies</Link></div>
                            <div className='text-neutral-500 hover:text-black   transition-colors'><Link>About</Link></div>
                            <div className='text-neutral-500 hover:text-black   transition-colors'><Link>Events</Link></div>
                            <div className='text-neutral-500 hover:text-black   transition-colors'><Link>Our Saint</Link></div>
                        </div>
                        <div className='w-full md:max-w-[352px]'>
                            <h2 className='text-2xl mb-3'>Contact Us</h2>
                            {/* <h5 className='text-lg mb-2'>Address</h5> */}
                            <div
                                onClick={() => window.open('https://www.google.com/maps/place/Swaminarayan+Temple/@21.229539,72.822553,2044m/data=!3m1!1e3!4m6!3m5!1s0x3be04eb966565bcf:0x6dbb611aa95a5fb!8m2!3d21.2295393!4d72.8225532!16s%2Fg%2F1tfvxm3h?hl=en&entry=ttu&g_ep=EgoyMDI1MDkxMC4wIKXMDSoASAFQAw%3D%3D', '_blank')}
                                className='flex items-start mb-4'>
                                <MdLocationOn className='text-2xl mr-2 mt-1 flex-shrink-0' />
                                <p className='text-gray-500 break-words'>
                                    Shree Swaminarayan Temple, Shree Sahajanand Chowk, Dabholi Char Rasta, Ved Road, Surat 395004, Gujarat, India.
                                </p>
                            </div>
                            <Link href='Tel:96012 91604' className='flex items-center text-base mb-4' ><IoCall className='text-prima text-2xl' /><span className='ml-2 text-neutral-500 hover:text-black   transition-colors'>96012 91604</span></Link>
                            <Link href='mailto:smvedroad@gmail.com' className='flex items-center text-base' ><MdEmail className='text-prima text-2xl' /><span className='ml-2 text-neutral-500 hover:text-black transition-colors'>smvedroad@gmail.com</span></Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
